import Dialog from "components/ui/Dialog/Dialog";
import Loader from "components/ui/Loader/Loader";
import Trans from "features/translation/components/Trans";
import Button from "components/ui/Button/Button";
import { useEffect, useState } from "react";
import { useDialog } from "context/DialogContext";
import Textarea from "components/form/Textarea/Textarea";
import { useGroupAccess } from "features/groups/hooks/useGroupAccess";
import PropTypes from "prop-types";
import Alert from "components/ui/Alert/Alert";
import useData from "hooks/useData";
import Radio from "components/form/Radio/Radio";
import LineBreakContainer from "components/ui/HTML/LineBreakContainer";

const GroupMemberAcceptDenyDialog = ({ groupMemberId, name, onCompleted }) => {
  const { getData } = useData();
  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState();
  const [ motivationAdmin, setMotivationAdmin ] = useState('');
  const [ error, setError ] = useState();
  const [ accept, setAccept ] = useState(true);
  const { hideDialog } = useDialog();
  const { working, allowAccess, denyAccess } = useGroupAccess();

  useEffect(
    () => {
      const load = async () => {
        setLoading(true);
        const { data } = await getData(`rest/group_member/${ groupMemberId }`);
        setData(data);
        setLoading(false);
      }
      load();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ groupMemberId ]
  );

  const handleResponse = async (response) => {
    const result = response && await response.json();

    if (response?.status !== 200) {
      setError(result?.message || 'Er ging helaas iets mis, probeer het later opnieuw.');
      return;
    }

    onCompleted(result);
    hideDialog();
  }

  const onConfirm = () => {
    accept ? onAccept() : onDeny();
  }

  const onAccept = async () => {
    const response = await allowAccess(groupMemberId);
    await handleResponse(response);
  }

  const onDeny = async () => {
    setError(null);

    if (!motivationAdmin) {
      setError('U dient de reden op te geven waarom u dit lid wil weigeren.');
      return;
    }

    const response = await denyAccess(groupMemberId, motivationAdmin);
    await handleResponse(response);
  }

  return (
    <Dialog title={ `Groepslid accepteren of weigeren` }>
      {
        loading || working
          ?
          <Loader/>
          :
          <>
            { error && <Alert message={ error }/> }
            <h3>{ name } heeft toegang aangevraagd met de volgende motivatie:</h3>
            <LineBreakContainer>
              "{ data.motivation_member[0]?.value }"
            </LineBreakContainer>
            <div className={ `dialog__row` }>
              <h3>Maak een keuze:</h3>
              <Radio label={ `Groepslid accepteren` }
                     checked={ accept }
                     group={ 'accept' }
                     onChange={ () => setAccept(() => true) }
              />
              <Radio label={ `Groepslid weigeren` }
                     checked={ !accept }
                     group={ 'accept' }
                     onChange={ () => setAccept(() => false) }
              />
            </div>
            <div className={ `dialog__row` }>
              {
                !accept &&
                <>
                  <h3><Trans text={ `Geef de reden dat u dit ${ name } de toegang tot deze groep wil weigeren` }/></h3>
                  <Textarea onChange={ event => setMotivationAdmin(event.target.value) } value={ motivationAdmin } autoFocus/>
                  <div className={ "text-small italic" }>
                    <Trans
                      text={ `Het lid zal een notificatie ontvangen met de opgegeven reden en uit de lijst worden verwijderd.` }/>
                  </div>
                </>
              }
            </div>

            <div className="dialog__buttons">
              <Button variant={ `ghost` } onClick={ () => hideDialog() }>Annuleren</Button>
              <Button variant={ `secondary` } onClick={ onConfirm }>Bevestigen</Button>
            </div>
          </>
      }
    </Dialog>
  );
}

GroupMemberAcceptDenyDialog.propTypes = {
  groupMemberId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onCompleted: PropTypes.func.isRequired
}

export default GroupMemberAcceptDenyDialog;
